import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const pill = (on) => `border px-4 py-3 text-left text-sm transition-colors ${on ? "border-[#c4dcca] bg-[#98bfa2] text-[#050807]" : "border-[rgba(152,191,162,0.25)] bg-[#0b120e] hover:border-[#98bfa2]"}`;

const Choice = ({ f, value, set }) => (
  <div className="flex flex-wrap gap-2">
    {f.options.map(([v, label]) => (
      <button key={v} type="button" data-testid={`anamnesi-${f.key}-${v}`} onClick={() => set(f.key, v)} className={pill(value === v)}>{label}</button>
    ))}
  </div>
);

const Scale = ({ f, value, set }) => (
  <div>
    <div className="grid grid-cols-5 gap-2 sm:grid-cols-10">
      {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
        <button key={n} type="button" data-testid={`anamnesi-${f.key}-${n}`} onClick={() => set(f.key, n)} className={`${pill(value === n)} text-center font-display text-xl font-800`}>{n}</button>
      ))}
    </div>
    <p className="mt-2 font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">1 = per niente · 10 = moltissimo</p>
  </div>
);

const YesNo = ({ f, form, set }) => (
  <div className="space-y-3">
    <div className="flex gap-2">
      {[["no", "No"], ["si", "Sì"]].map(([v, label]) => (
        <button key={v} type="button" data-testid={`anamnesi-${f.key}-${v}`} onClick={() => set(f.key, v)} className={`${pill(form[f.key] === v)} min-w-20 text-center`}>{label}</button>
      ))}
    </div>
    {form[f.key] === "si" && (
      <Textarea data-testid={`anamnesi-${f.key}-detail`} rows={2} maxLength={500} placeholder={f.placeholder} value={form[`${f.key}_detail`]} onChange={(e) => set(`${f.key}_detail`, e.target.value)} />
    )}
  </div>
);

const Num = ({ f, value, set }) => (
  <div className="flex max-w-[220px] items-center gap-3">
    <Input data-testid={`anamnesi-${f.key}-input`} type="number" inputMode="decimal" min={f.min} max={f.max} step={f.step || "1"} value={value} onChange={(e) => set(f.key, e.target.value)} className="h-12" />
    <span className="font-mono text-xs uppercase tracking-widest text-[#a3b1aa]">{f.unit}</span>
  </div>
);

export const AnamnesiField = ({ f, form, set }) => (
  <div data-testid={`anamnesi-field-${f.key}`} className="border-t border-white/5 pt-6">
    <p className="mb-3 text-base text-[#f4f7f5]">{f.label}</p>
    {f.type === "choice" && <Choice f={f} value={form[f.key]} set={set} />}
    {f.type === "scale" && <Scale f={f} value={form[f.key]} set={set} />}
    {f.type === "yesno" && <YesNo f={f} form={form} set={set} />}
    {f.type === "number" && <Num f={f} value={form[f.key]} set={set} />}
    {f.type === "text" && <Textarea data-testid={`anamnesi-${f.key}-input`} rows={3} maxLength={500} value={form[f.key]} onChange={(e) => set(f.key, e.target.value)} />}
  </div>
);
